export const clearFormat = (text: string) => {
  return text.replace(/\D/g, "");
};

export const range = (start: number, stop: number, step = 1) =>
  Array(Math.ceil((stop - start) / step))
    .fill(start)
    .map((x, y) => x + y * step);

export const getInitials = function (string: string) {
  var names = string.split(" "),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

export const makePassword = (): number => {
  return Math.floor(100000 + Math.random() * 900000);
};

export const formatCpfCnpj = (cpfCnpj: string) => {
  if(!cpfCnpj) return '';
  
  const cpfCnpjRaw = clearFormat(cpfCnpj);
  if (cpfCnpjRaw.length > 11) {
    return cpfCnpjRaw.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
  } else {
    return cpfCnpjRaw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
};

export const formatCpfCnpjMask = (cpfCnpj: string) => {
  const cpfCnpjRaw = clearFormat(cpfCnpj);

  if (cpfCnpjRaw.length > 11) {
    return cpfCnpjRaw.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
  } else {
    return cpfCnpjRaw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "***.$2.$3-**");
  }
};

export const formatCep = (cep: string | null) => {
  if(!cep) return '';
  const cepRaw = clearFormat(cep);

  return cepRaw.replace(
    /^(\d{5})(\d{3})/,
    "$1-$2"
  );
};


export const isEmpty = (value: string | null) => {
  return value == null || value.trim().length === 0;
};

export const converterDias = (numero: number | undefined | null): string => {
  if (!numero || numero == 0 ) {
    return ""
  }

  const dias = Math.floor(numero); // Parte inteira representa os dias
  const horasDecimais = (numero - dias) * 24; // Parte decimal em horas
  const horas = Math.floor(horasDecimais); // Parte inteira das horas
  const minutos = Math.round((horasDecimais - horas) * 60); // Parte decimal das horas em minutos

  let resultado = '';

  // Se o número de dias for maior que zero, adiciona ao resultado
  if (dias > 0) {
    resultado += `${dias} dia${dias !== 1 ? 's' : ''}`;
  }

  // Se o número de horas for maior que zero, adiciona ao resultado
  if (horas > 0) {
    if (resultado) resultado += ' e '; // Conecta dias e horas com "e"
    resultado += `${horas} hora${horas !== 1 ? 's' : ''}`;
  }

  // Se as horas forem zero e os minutos forem maiores que zero, exibe minutos
  if (horas === 0 && minutos > 0) {
    if (resultado) resultado += ' e ';
    resultado += `${minutos} minuto${minutos !== 1 ? 's' : ''}`;
  }

  return resultado || '0 minutos'; // Caso seja 0, exibe "0 minutos"

}

export const formatCurrency = (value: string) => {
  let num = value.replace(/\D/g, "")
  return (Number(num) / 100).toFixed(2);
}

export const validarCpfCnpj = (documento: string): boolean => {
  const doc = documento.replace(/\D/g, "");
  if (doc.length === 11) {
    return validarCpf(doc);
  } else if (doc.length === 14) {
    return validarCnpj(doc);
  }
  return false;
};

const validarCpf = (cpf: string): boolean => {
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf[i]) * (10 - i);
  }
  let digito1 = soma % 11;
  digito1 = digito1 < 2 ? 0 : 11 - digito1;
  if (parseInt(cpf[9]) !== digito1) return false;
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf[i]) * (11 - i);
  }
  let digito2 = soma % 11;
  digito2 = digito2 < 2 ? 0 : 11 - digito2;
  return parseInt(cpf[10]) === digito2;
};

const validarCnpj = (cnpj: string): boolean => {
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;
  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma += parseInt(cnpj[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digito1 = soma % 11;
  const resultado1 = soma < 11 ? 0 : 11 - digito1;
  if (parseInt(cnpj[12]) !== resultado1) return false;
  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma += parseInt(cnpj[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digito2 = soma % 11;
  const resultado2 = soma < 11 ? 0 : 11 - digito2;
  return parseInt(cnpj[13]) === resultado2;
};